<script setup lang="ts">
import type { NuxtError } from '#app'
const { $auth } = useNuxtApp()

const props = defineProps({
  error:  Object as () => NuxtError
})

const handleError = () => clearError({ redirect: '/' })

const image = computed(() => {
  switch (props.error?.statusCode) {
    case 404: return '/img/404.webp'
    case 500: return '/img/500.webp'
    case 600: return '/img/VideoError.svg'
  }
})

const errorTitle = computed(() => {
  if (props.error?.statusCode === 404) {
    return 'صفحه مورد نظر یافت نشد'
  } else {
    return 'متاسفیم، مشکلی پیش آمده!'
  }
})

const errorMessage = computed(() => {
  if (props.error?.statusMessage) return props.error.statusMessage
  
  switch (props.error?.statusCode) {
    case 404:
      return 'اطلاعات مورد نظر یافت نشد'
    case 403:
      return 'شما مجوز دسترسی به این بخش را ندارید'
    case 401:
      return 'برای دسترسی به این بخش ابتدا وارد حساب کاربری خود شوید'
    case 500:
      return 'خطایی در دریافت اطلاعات رخ داده است'
    case 600:
      return 'مرورگر شما قادر به پخش این ویدیو نیست. لطفاً از مرورگر دیگری مانند Google Chrome یا Mozilla Firefox استفاده کنید.';
    default:
      return 'خطایی رخ داده است.'
  }
})
</script>

<template>
  <UApp>
    <NuxtLoadingIndicator />
  
    <Teleport to="body">
      <LayoutHeader v-if="$auth.isLoggedIn()" class="app-sidebar" />
    </Teleport>
  
    <div class="flex items-center justify-center h-full">
      <UCard class="w-72 md:w-96" :ui="{ body: 'bg-red-200 dark:bg-red-500 rounded-t-lg' }">
        <template #header>
          <div class="flex items-center gap-2 text-center text-sm font-bold text-neutral-700 dark:text-neutral-100">
            <UIcon name="i-solar-danger-circle-linear" class="size-6 text-neutral-700 dark:text-neutral-100" />
            <h1>{{ errorTitle }}</h1>
          </div>
        </template>
        <div class='flex flex-col gap-4 sm:gap-6 items-center justify-center'>
          <NuxtImg v-if="image" :src="image" provider="local" sizes="md:300px" :placeholder="[100, 100]" alt='error info'
            class="w-20 lg:w-40 aspect-w-8 rounded-lg bg-contain" />
  
          <p class='text-xs font-medium text-neutral-700 dark:text-neutral-100'>
            {{ errorMessage }}
          </p>
  
          <UButton block variant="solid" trailing-icon="i-solar-home-2-linear" size="sm"
            @click="handleError">
            صفحه اصلی
          </UButton>
        </div>
      </UCard>
    </div>
  </UApp>
</template>
